// Weiche Uebergaenge im Warenkorb-Drawer (snippets/cart-drawer.liquid).
// Der Drawer wird nach jeder Aenderung per innerHTML komplett ersetzt. Ein MutationObserver vergleicht danach die
// Artikel anhand von data-key (snippets/cart-item.liquid) mit dem letzten Stand, noch bevor der Browser zeichnet:
//   neue Artikel klappen auf und blenden ein, Bilder erscheinen weich, sobald sie geladen sind
//   entfernte Artikel werden als stillgelegte Kopie an alter Stelle eingesetzt und klappen weich zu
//   letzter Artikel entfernt: alter Inhalt blendet als Kopie aus, der leere Warenkorb blendet ein
// Kopien werden stillgelegt (eigene Elemente wie su-shipping-bar oder slideshow-section werden zu div),
// damit deren Skripte nicht noch einmal anlaufen.
(() => {
  if (window.__suCartAnim) return;
  window.__suCartAnim = true;
  const root = document.querySelector('cart-drawer');
  if (!root || !Element.prototype.animate) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(.22,.61,.36,1)';
  const isOpen = () => document.body.classList.contains('page-overlay-cart-on');
  const inner = () => root.querySelector('.drawer__inner');
  const items = () => [...root.querySelectorAll('.wt-cart__list > .cart-item:not(.is-su-leaving)')];
  const keyOf = (li) => li.dataset.key || li.id;
  const crossSellIds = () => [...root.querySelectorAll('.wt-cart__cross-sell [data-block-id]')].map((el) => el.dataset.blockId).join(',');
  let snap = null;

  function take() {
    const list = items();
    const box = inner();
    const boxRect = box && box.getBoundingClientRect();
    snap = {
      keys: list.map(keyOf),
      nodes: new Map(list.map((li) => [keyOf(li), li])),
      heights: new Map(list.map((li) => [keyOf(li), li.getBoundingClientRect().height])),
      crossSell: crossSellIds(),
      panels: box ? [...box.children].filter((el) => !el.matches('header, .is-su-leaving')).map((el) => {
        const r = el.getBoundingClientRect();
        return { node: el, top: r.top - boxRect.top, left: r.left - boxRect.left, width: r.width, height: r.height };
      }) : [],
    };
  }

  // Eigene Elemente in der Kopie durch div ersetzen (innen zuerst), Kopie fuer Maus, Tastatur und Screenreader sperren
  function neutralize(node) {
    [...node.querySelectorAll('*')].reverse().forEach((el) => {
      if (!el.tagName.includes('-')) return;
      const div = document.createElement('div');
      for (const attr of el.attributes) if (attr.name === 'class' || attr.name === 'style') div.setAttribute(attr.name, attr.value);
      while (el.firstChild) div.appendChild(el.firstChild);
      el.replaceWith(div);
    });
    node.removeAttribute('id');
    node.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    node.querySelectorAll('.loading-overlay').forEach((el) => el.classList.add('hidden'));
    node.classList.add('is-su-leaving');
    node.setAttribute('aria-hidden', 'true');
    node.inert = true;
    node.style.pointerEvents = 'none';
    return node;
  }

  function leave(node, height, ref, list) {
    neutralize(node);
    Object.assign(node.style, { overflow: 'hidden', boxSizing: 'border-box' });
    list.insertBefore(node, ref);
    const anim = node.animate(
      [
        { height: height + 'px', opacity: 1, transform: 'none' },
        { height: height + 'px', opacity: 0, transform: 'translateX(18px)', offset: 0.42 },
        { height: '0px', opacity: 0, transform: 'translateX(18px)', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' },
      ],
      { duration: 480, easing: EASE, fill: 'forwards' }
    );
    anim.onfinish = anim.oncancel = () => node.remove();
  }

  function softImages(scope, delay) {
    scope.querySelectorAll('img').forEach((img) => {
      if (img.complete && img.naturalWidth) return;
      img.style.opacity = '0';
      const show = () => {
        img.style.opacity = '';
        img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, delay: Math.max(0, delay - 200), easing: 'ease-out', fill: 'backwards' });
      };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', () => { img.style.opacity = ''; }, { once: true });
    });
  }

  function enter(li, delay) {
    softImages(li, delay);
    const height = li.getBoundingClientRect().height;
    if (!height) return;
    Object.assign(li.style, { overflow: 'hidden', boxSizing: 'border-box' });
    const anim = li.animate(
      [
        { height: '0px', opacity: 0, transform: 'translateY(-8px)', paddingTop: '0px', paddingBottom: '0px' },
        { height: height + 'px', opacity: 0, transform: 'translateY(-8px)', offset: 0.45 },
        { height: height + 'px', opacity: 1, transform: 'none' },
      ],
      { duration: 560, delay, easing: EASE, fill: 'backwards' }
    );
    anim.onfinish = anim.oncancel = () => { li.style.overflow = ''; li.style.boxSizing = ''; };
  }

  function fadeIn(el, delay, duration = 420) {
    if (el) el.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration, delay, easing: EASE, fill: 'backwards' });
  }

  // Letzter Artikel entfernt: alte Bereiche (ohne Kopfzeile) als Kopie an alter Stelle ausblenden, neuen Inhalt einblenden
  function toEmpty(prev) {
    const box = inner();
    if (!box) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    prev.panels.forEach((p) => {
      if (!p.height) return;
      const ghost = neutralize(p.node);
      Object.assign(ghost.style, { position: 'absolute', top: p.top + 'px', left: p.left + 'px', width: p.width + 'px', height: p.height + 'px', margin: '0', zIndex: '2', background: '#fff', overflow: 'hidden' });
      box.appendChild(ghost);
      const anim = ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, easing: 'ease-out', fill: 'forwards' });
      anim.onfinish = anim.oncancel = () => ghost.remove();
    });
    [...box.children].forEach((el) => { if (!el.matches('header, .is-su-leaving')) fadeIn(el, 180, 460); });
  }

  function onChange() {
    const prev = snap;
    const list = items();
    const keys = list.map(keyOf);
    const crossSell = crossSellIds();
    if (!prev || reduce.matches || (keys.join('|') === prev.keys.join('|') && crossSell === prev.crossSell)) return take();
    // Bei geschlossenem Drawer faehrt er gleich herein, die Artikelanimation startet danach
    const delay = isOpen() ? 0 : 280;
    const ul = root.querySelector('.wt-cart__list');

    if (ul) {
      prev.keys.forEach((key, index) => {
        if (keys.includes(key)) return;
        const node = prev.nodes.get(key);
        const height = prev.heights.get(key);
        if (!node || !height || !isOpen()) return;
        let ref = null;
        for (let j = index + 1; j < prev.keys.length && !ref; j++) {
          const pos = keys.indexOf(prev.keys[j]);
          if (pos > -1) ref = list[pos];
        }
        leave(node, height, ref, ul);
      });
      list.forEach((li, i) => { if (!prev.keys.includes(keys[i])) enter(li, delay); });
    } else if (prev.keys.length && isOpen()) {
      toEmpty(prev);
    }
    const cs = root.querySelector('.wt-cart__cross-sell');
    if (cs && crossSell !== prev.crossSell) { fadeIn(cs, delay + 120); softImages(cs, delay + 120); }
    take();
  }

  new MutationObserver((records) => {
    // Nur echte Neuaufbauten auswerten, nicht Swiper-Klassen oder die eigenen Kopien
    const relevant = records.some((r) => [...r.addedNodes, ...r.removedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('is-su-leaving')));
    if (relevant) onChange();
  }).observe(root, { childList: true, subtree: true });

  // Lagen kurz vor einer Aenderung frisch messen (Bilder koennen seit dem letzten Stand nachgeladen sein)
  root.addEventListener('pointerdown', take, true);
  root.addEventListener('keydown', take, true);
  document.addEventListener('cart-drawer-open', () => setTimeout(take, 350));
  take();
})();
